import React from 'react';
import { Hint, HintProps } from '../Hint';
import { useTranslation } from 'react-i18next';
import { useNewNavigationOnboarding } from '../AppLayout/MasterLayout/NewNavigationOnboardingContext';
import useScreenSize from '../../utils/useScreenSize';

interface NewNavigationOnboardingHintMobileProps {
  children: JSX.Element;
  title?: string;
  description: string;
  step?: string;
  open: boolean;
  actions?: HintProps['actions'];
  isNew?: boolean;
  onClose?: () => void;
  width?: number;
}

const NewNavigationOnboardingHintMobile = ({
  children,
  title,
  description,
  step,
  open,
  actions,
  isNew = false,
  onClose,
  width,
}: NewNavigationOnboardingHintMobileProps) => {
  const { t } = useTranslation();
  const { dismissWalkthrough, incrementStep } = useNewNavigationOnboarding();
  const { isSmallScreen } = useScreenSize();

  // Note: this y offset makes this hint sticked to right side with 60px margin
  const offset = isSmallScreen ? { y: -90, x: 0 } : { x: 8 }; 

  return (
    <Hint
      open={open}
      onClose={onClose || dismissWalkthrough}
      isNew={isNew}
      title={title}
      description={description}
      placement={isSmallScreen ? 'bottom-start' : 'left'}
      disablePortal={false}
      preventOverflow={true}
      actions={actions || {
        secondary: {
          label: t('Next'),
          onClick: incrementStep,
          buttonProps: {
            variant: 'text',
          },
        }
      }}
      width={width || 314}
      maxWidth={width || 314}
      mobileMaxWidth={width || 314}
      bottomLeftText={step}
      offset={offset}
      useDesktopButtonDesign
    >
      {children}
    </Hint>
  );
};

export default NewNavigationOnboardingHintMobile;
